import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormField, MatOption, MatSelect, MatSuffix } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { UserColumn } from '../../models/users-columns';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { minLengthIfNotEmpty } from '../../../../../../validators/min-length-if-not-empty.validator';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-user-filters',
  standalone: true,
  imports: [
    MatSelect,
    MatInput,
    MatFormField,
    MatIcon,
    MatSuffix,
    MatIconButton,
    MatOption,
    MatTooltip,
    ReactiveFormsModule
  ],
  templateUrl: './user-filters.component.html',
  styleUrl: './user-filters.component.scss'
})
export class UserFilters {
  @Input() columns: UserColumn[] = [];
  @Output() filterApplied = new EventEmitter<{ columnName: string | null; value: string } | null>();
  selectedColumn = '';
  readonly tooltipText = 'Type 3 or more characters to search, or leave the field blank to view all results.';
  searchControl = new FormControl('', {
    nonNullable: true,
    validators: [minLengthIfNotEmpty(3)]
  });

  search() {
    this.filterApplied.emit({
      columnName: this.selectedColumn || null,
      value: this.searchControl.value || ''
    });
  }

  clearSearch() {
    this.searchControl.setValue('');
    this.search();
  }

  clearFilters() {
    this.selectedColumn = '';
    this.searchControl.setValue('');
    this.filterApplied.emit(null);
  }
}
